import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import { Download as DownloadIcon } from "@mui/icons-material";

const DownloadTemplateDialog = ({
  open,
  onClose,
  onDownload,
  formId,
  loading = false,
}) => {
  const [downloadType, setDownloadType] = useState("pdf");

  const handleDownloadTypeChange = (event) => {
    setDownloadType(event.target.value);
  };

  const handleDownload = () => {
    onDownload(formId, downloadType);
  };

  const handleClose = () => {
    if (!loading) {
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown={loading}
    >
      <DialogTitle>Download Template</DialogTitle>
      <DialogContent>
        <Box sx={{ py: 2 }}>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Select the format you want to download:
          </Typography>

          <FormControl component="fieldset">
            <FormLabel component="legend">Download Format</FormLabel>
            <RadioGroup
              value={downloadType}
              onChange={handleDownloadTypeChange}
              sx={{ mt: 1 }}
            >
              <FormControlLabel
                value="pdf"
                control={<Radio />}
                label="PDF Template"
                disabled={loading}
              />
              <FormControlLabel
                value="image"
                control={<Radio />}
                label="Image Template(s)"
                disabled={loading}
              />
            </RadioGroup>
          </FormControl>

          <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
            {downloadType === "pdf"
              ? "Download the PDF template file."
              : "Download all available image templates for this form (may include multiple variations)."}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading} color="inherit">
          Cancel
        </Button>
        <Button
          onClick={handleDownload}
          variant="contained"
          color="primary"
          disabled={loading}
          startIcon={
            loading ? <CircularProgress size={16} /> : <DownloadIcon />
          }
        >
          {loading ? "Downloading..." : "Download"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DownloadTemplateDialog;
